import React, { useReducer, useEffect } from 'react';
import { Box, TextField, Tooltip } from '@mui/material';
import DefaultModal from '../Utils/DefaultModal';
import { api } from '../../services/api';
import { lockedReducer } from '../Utils/reducers';
import ColorButton from '../Buttons/ColorButton';
import toast from 'react-hot-toast';
import { NumericFormatInput } from '../Utils/NumericInput';
import validateData from './validateTransportadora';
import MegaAutoComplete from '../Utils/megautocomplete';
import { PercentFormatInputDefault } from '../Utils/PercentInputDefault';


const url = '/frete/'
const submit = async (setLoader, data, getData, handleClose) => {

    setLoader(true)
    let res = null
    if (data.id)
        res = await api.patch(`${url}transportadora/${data.id}`, data)
    else
        res = await api.post(url + 'transportadora/create/', data)
    if (res.status === 200) {
        toast.success(`Transportadora ${!data.id ? 'adicionado' : 'editado'} com sucesso`)
        getData()
    } else {
        toast.error(res.data.detail)
        setLoader(false)
        return
    }
    setLoader(false)
    handleClose()
}


const loadRetrieve = async (id, setState, setLoader) => {
    setLoader(true)
    const res = await api.get(url + 'transportadora/empresas/' + `${id}`)
    if (res.status === 200) {
        setState({ empresas: res.data })
    }
    setLoader(false)
}


const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Cadastrar'
}

const EditTransportadoras = ({ data, handleClose, reloadData, setLoader }) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        editRow: null,
        empresas: [],
        transportadora: '',
        nome_rota_regiao: '',
        cobrado: '',
        frete_minimo: '',
        ...data,
        id: data.id ? data.id : 0

    })

    const validTable = validateData(state)

    useEffect(() => {
        if (data.id)
            loadRetrieve(data.id, setState, setLoader)
    }, [setLoader, data.id])

    return (
        <>
            <DefaultModal
                dialogProps={{ maxWidth: "sm" }}
                handleClose={handleClose}
                open={true}
                title={`${getTitle(state)} Transportadora`}
                content={
                    <Box className='item-content-modal noborder'>

                        <Box className='item-profile-row'  >
                            <MegaAutoComplete

                                id="transportadoraEmpresa"
                                multiple={true}
                                value={state.empresas}
                                onChange={(data) => { setState({ empresas: data }) }}
                                noOptionsText={'Digite para procurar uma empresa'}
                                timeoutUrl='/frete/filiais'
                                timeoutParam='label'
                                label='Empresas'
                            />
                        </Box>

                        <Box className='item-profile-row'>

                            <MegaAutoComplete
                                multiple={false}
                                value={state.transportadora}
                                onChange={(data) => { setState({ transportadora: data }) }}
                                noOptionsText={'Digite para procurar uma transportadora'}
                                timeoutUrl='/frete/transportadoras'
                                timeoutParam='label'
                                label='Transportadora'
                            />

                        </Box>

                        <Box className='item-profile-row'>

                            <MegaAutoComplete
                                multiple={false}
                                value={state.nome_rota_regiao}
                                onChange={(data) => { setState({ nome_rota_regiao: data }) }}
                                noOptionsText={'Digite para procurar uma transportadora'}
                                timeoutUrl='/frete/rota_regiao/'
                                timeoutParam='label'
                                label='Rota/Região'
                            />

                        </Box>

                        <Box className='item-profile-row'>

                            <TextField
                                id="valor_do_frete"
                                type="text"
                                label="% cobrado"
                                value={state.cobrado}
                                onChange={(e) => { setState({ 'cobrado': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 50
                                }}
                                InputProps={{
                                    inputComponent: PercentFormatInputDefault,
                                }}
                                sx={{ width: '50%' }}
                            />

                            <TextField
                                id="frete_minimo"
                                type="text"
                                label="Frete Mínimo em R$"
                                value={state.frete_minimo}
                                onChange={(e) => { setState({ 'frete_minimo': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                InputProps={{
                                    inputComponent: NumericFormatInput,
                                }}

                                sx={{ width: '50%' }}
                            />



                        </Box>



                    </Box>
                }

                action={

                    <Tooltip title={validTable} placement="left">
                        <span>
                            <ColorButton disabled={validTable} onClick={() => submit(setLoader, state, reloadData, handleClose)}>Salvar</ColorButton>
                        </span>
                    </Tooltip>

                }
            />

        </>
    )
}

export default EditTransportadoras;